module.exports = __webpack_public_path__ + "img/peny.e917e7a3.jpg";